import {Node, NodeSpec} from 'prosemirror-model';


import {schema} from "../../config/schema";


export interface ImageAttrs {
    guid: string;
    s3FileName: string;
    display: string;
    alt: string | null;
    title: string | null;
    src: string | null;
}

export interface ImageNode extends Node {
    attrs: ImageAttrs
}

export const isImageNode = (node: Node): node is ImageNode => {
    return node.type === schema.nodes.image;
}

export const DEFAULT_DISPLAY = 'normal';

const getImgAttributes = (dom: HTMLElement): ImageAttrs => {
    const element = dom as HTMLOListElement;
    return {
        guid: element.getAttribute('data-guid') as string,
        s3FileName: element.getAttribute('data-s3FileName') as string,
        src: element.getAttribute('src'),
        display: element.getAttribute('data-display') as string,
        title: element.getAttribute('title'),
        alt: element.getAttribute('alt'),
    }
}

export const image: NodeSpec = {
    group: 'block',
    inline: false,
    attrs: {
        guid: {default: null},
        s3FileName: {default: null},
        src: {default: null},
        display: {default: DEFAULT_DISPLAY},
        alt: {default: null},
        title: {default: null},
    },
    draggable: true,
    dragHandle: true,
    selectable: true,
    isolating: true,
    parseDOM: [
        {
            tag: 'img[src]',
            getAttrs: getImgAttributes,
        },
        {
            tag: 'img[data-s3filename]',
            getAttrs: getImgAttributes,
        },
    ],
    toDOM(node) {
        const {alt, title, src, s3FileName, display, guid} = node.attrs as ImageAttrs;
        return [
            'img',
            {
                alt,
                title,
                src,
                "data-s3FileName": s3FileName,
                "data-display": display,
                "data-guid": guid,
                class: 'pm-image',
            }
        ];
    },
}
